import { render, staticRenderFns } from "./FaqBox.vue?vue&type=template&id=d9a5e426"
import script from "./FaqBox.vue?vue&type=script&lang=js"
export * from "./FaqBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports